import { Injectable } from "@angular/core";
import { HorarioAfericaoDTO } from "app/model/dtos/mob/horario-afericao.dto";
import { RelatorioHorarioHorarioAfericaoListDTO } from "app/model/dtos/mob/relatorioHorarioAfericao.dto";
import { HorarioAfericaoController } from '../../controllers/mob/horario-afericao.controller';
import { LoaderService } from "../loader.service";
import { HorarioAfericaoSearch } from './horario-afericao.search';



@Injectable({
    providedIn: "root",
})

export class HorarioAfericaoService{
    constructor(
        private _horarioAfericaoController: HorarioAfericaoController,
        private _loaderService: LoaderService
    ) {}

    async find(horarioAfericaoSearch?: HorarioAfericaoSearch): Promise<Array<HorarioAfericaoDTO>>{
        this._loaderService.show();
        try{
            return await this._horarioAfericaoController.find((horarioAfericaoSearch && horarioAfericaoSearch.getFilters()) || null).finally(() => this._loaderService.hide()); 
        } catch(error) {
            this._loaderService.hide()
            console.log(error);
            return [];
        }
    }
    
    async findRelatorio(horarioAfericaoSearch?: HorarioAfericaoSearch): Promise<Array<RelatorioHorarioHorarioAfericaoListDTO>>{
        this._loaderService.show();
        try{
            return await this._horarioAfericaoController.findRelatorio((horarioAfericaoSearch && horarioAfericaoSearch.getFilters()) || null).finally(() => this._loaderService.hide()); 
        } catch(error) {
            this._loaderService.hide()
            console.log(error);
            return [];
        }
    }

    async sync(): Promise<JSON> {
        this._loaderService.show();
        return this._horarioAfericaoController.sync().finally(() => this._loaderService.hide());
    }

    async relatorioHorarioAfericao(horarioAfericaoSearch?: HorarioAfericaoSearch): Promise<Blob>{
        this._loaderService.show();
        try{
            return await this._horarioAfericaoController.relatorioHorarioAfericao((horarioAfericaoSearch && horarioAfericaoSearch.getFilters()) || null).finally(() => this._loaderService.hide()); 
        } catch(error) {
            this._loaderService.hide()
            console.log(error);
            return null;
        }
    }
}